export const fileInput = [() => {
  return {
    restrict: 'A',
    require: "ngModel",
    link: (scope, elem, attrs,ngModel) => {
        elem.on("change", function(e) {
            var file = elem[0].file;
            ngModel.$setViewValue(file);
            var path = angular.element(document.querySelector('#path'));
            path[0].value = elem[0].value;
        })
    }
  };
}];



// WEBPACK FOOTER //
// ./src/app/common/directives/file-input.js